/* eslint-disable */
import React, { useCallback, useState } from "react";

import { Modal } from "antd";

import api from "../../services/api";
import { notifyError, notifySucces } from "../../utils/notifications";
import * as S from "./styles";
import { TErrorSSO, TModalActivateSSO, User, Group } from "./types";

const ModalActivateSSO = ({
  setForceUpdate,
  isVisible,
  onCloseModal,
  userData,
  groupData,
  fetch,
  endpoint,
  type,
}: TModalActivateSSO) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleManageSSO = useCallback(async (data: User | Group) => {
    setIsLoading(true);
    try {
      const response = await api.patch(endpoint, {
        is_sso_active:
          type === "user"
            ? !(data as User)?.is_sso_active
            : !(data as Group)?.is_sso_active,
        role_id: type === "user" ? undefined : data.id,
        user_id: type === "user" ? data.id : undefined,
      });

      if (response.statusCode === 200) {
        notifySucces(
          response.message,
          true,
          type === "user" ? (data as User)?.username : (data as Group)?.name
        );
        fetch();
        return;
      }

      if (response.statusCode === 409) {
        notifyError(response.message, "ERROR_HIGHLIGHT", false, true);
        return;
      }
    } catch (error) {
      const err = error as TErrorSSO;
      notifyError(err.message);
    } finally {
      setIsLoading(false);
      onCloseModal(false);
    }
  }, []);

  return (
    <Modal
      title={
        <span style={{ fontWeight: "bold" }}>
          {userData?.is_sso_active || groupData?.is_sso_active
            ? "Inativar SSO"
            : "Ativar SSO"}
        </span>
      }
      visible={isVisible}
      onCancel={() => onCloseModal(false)}
      style={{
        borderRadius: "8px",
      }}
    >
      <S.Container>
        <S.TitleWrapper>
          <S.Title>
            {type === "user"
              ? userData?.is_sso_active
                ? `Deseja realmente inativar o SSO para o usuário ${userData?.username}?`
                : `Deseja realmente ativar o SSO para o usuário ${userData?.username}?`
              : groupData?.is_sso_active
              ? `Deseja realmente inativar o SSO para o grupo ${groupData?.name}?`
              : `Deseja realmente ativar o SSO para o grupo ${groupData?.name}?`}
          </S.Title>
          <S.Description>
            {type === "user"
              ? userData?.is_sso_active
                ? "Ao realizar a inativação, o usuário não poderá mais realizar login via SSO, podendo acessar apenas com usuário e senha, o que reforça a segurança do processo."
                : "Ao realizar a ativação, o usuário não poderá mais realizar login com usuário e senha, podendo acessar apenas via SSO, o que reforça a segurança do processo."
              : groupData?.is_sso_active
              ? `Ao realizar a inativação, os usuários desse grupo não poderão mais realizar login via SSO, podendo acessar apenas com usuário e senha, o que reforça a segurança do processo.`
              : `Ao realizar a ativação, os usuários desse grupo não poderão mais realizar login com usuário e senha, podendo acessar apenas via SSO, o que reforça a segurança do processo.`}
          </S.Description>
        </S.TitleWrapper>
        <S.ButtonWrapper>
          <S.CancelButton onClick={() => onCloseModal(false)}>
            Cancelar
          </S.CancelButton>

          <S.ActivateSSOButton
            onClick={() => {
              handleManageSSO(type === "user" ? userData : groupData);
              setForceUpdate();
            }}
          >
            {isLoading && <S.Loader />} Confirmar
          </S.ActivateSSOButton>
        </S.ButtonWrapper>
      </S.Container>
    </Modal>
  );
};

export default ModalActivateSSO;
